
export default {
    props: {
        setting: Object,
    },
};
